import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { SitemateTaskTypes, Team } from '@site-mate/dashpivot-shared-library';

import { WINDOW } from 'app/shared/factory/window.factory';
import { TaskCreationMode } from 'app/shared/model/sitemate/task-creation-mode.enum';
import { ISitemateTaskDefinitionWeb } from 'app/shared/model/task-definition.model';
import { DownloaderService } from 'app/shared/service/downloader.service';

@Component({
  selector: 'cc-template-links-modal-completed',
  templateUrl: './template-links-modal-completed.component.html',
  styleUrls: [
    '../../templates-library/templates-selector/templates-selector-common.scss',
    './template-links-modal-completed.component.scss',
  ],
})
export class TemplateLinksModalCompletedComponent {
  @Input() taskDefinition: ISitemateTaskDefinitionWeb;
  @Input() taskCreationMode: TaskCreationMode;
  @Input() team: Team;
  @Input() taskType: SitemateTaskTypes;
  @Output() readonly downloadQrCodePoster = new EventEmitter<void>();
  @Output() readonly copyLink = new EventEmitter<void>();
  @Output() readonly closeModal = new EventEmitter<void>();

  readonly taskTypes = { ...SitemateTaskTypes };
  isLinkCopied = false;

  constructor(
    private readonly downloaderService: DownloaderService,
    @Inject(WINDOW) private readonly window: Window,
  ) {}

  onLinkCopied(): void {
    this.isLinkCopied = true;
    this.copyLink.emit();
  }

  onQrCodePosterDownload(): void {
    const qrCodePosterUrl = this.downloaderService
      .getQrCodePosterUrl({
        teamId: this.team.id,
        taskUrl: this.taskDefinition.url,
      })
      .toString();
    this.window.open(qrCodePosterUrl, '_blank');
    this.downloadQrCodePoster.emit();
  }

  onCloseModal(): void {
    this.closeModal.emit();
  }
}
